import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors } from '@/utils/constants';

export const useNavigationCollapseStyles = makeStyles(
  ({ spacing, palette }) => ({
    navigationDropdownContent: {
      zIndex: 10,
      padding: spacing(2, 2),
      backgroundColor: palette.primary.dark,
      position: 'relative',
    },
    subMenuWrapper: {
      backgroundColor: PrimaryColors.main,
      margin: spacing(0, -2),
      '& .sub-menu-content': {
        padding: spacing(1, 4),
      },
    },
  }),
  {
    name: 'NavigationCollapse',
  },
);
